export default{
    empty: 'Δεν υπάρχουν εγγραφές ακόμα',
    noData: 'Πρόσθεσε την πρώτη εγγραφή για να παρακολουθείς την πρόοδο ανά ραντεβού.',
    title: 'Σημειώσεις ανά συνεδρία',
    openAll: 'Επέκταση όλων των συνεδριών (ανοιχτές σημειώσεις)'
}